import { NormalImageAndTextAndTextAreaCombinationInputFields } from "@/components";
import React from "react";

const StartYourBusinessFieldCardsSection = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
  handleTextEditorInputChange,
}) => {
  return (
    <>
      <NormalImageAndTextAndTextAreaCombinationInputFields
        stateDetails={stateDetails}
        isFetching={isFetching}
        labelText="Field Cards"
        fieldId="start-your-business-section-3-cards"
        handleTextInputChange={handleTextInputChange}
        handleTextEditorInputChange={handleTextEditorInputChange}
        translateField={true}
        cards={[
          {
            card_id: "start-your-business-section-3-field-card-1",
            types: ["TEXT", "TEXT_AREA", "TEXT_EDITOR"],
            text_field_id: "start-your-business-section-3-field-card-heading-1",
            text_area_field_id:
              "start-your-business-section-3-field-card-short-description-1",
            text_editor_field_id:
              "start-your-business-section-3-field-card-description-1",
            text_input_placeholder: "Heading",
            textarea_input_placeholder: "Short Description",
            text_editor_placeholder: "Description",
          },
          {
            card_id: "start-your-business-section-3-field-card-2",
            types: ["TEXT", "TEXT_AREA", "TEXT_EDITOR"],
            text_field_id: "start-your-business-section-3-field-card-heading-2",
            text_area_field_id:
              "start-your-business-section-3-field-card-short-description-2",
            text_editor_field_id:
              "start-your-business-section-3-field-card-description-2",
            text_input_placeholder: "Heading",
            textarea_input_placeholder: "Short Description",
            text_editor_placeholder: "Description",
          },
        ]}
      />
    </>
  );
};

export default StartYourBusinessFieldCardsSection;
